import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HowItWorksModalComponent } from 'src/app/pages/home-page/how-it-works-modal/how-it-works-modal.component';
import { FgbModalService } from 'src/app/shared/components/modals/fgb-modal.service';

@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  private _destroyed$ = new Subject<void>();
  showNewFanWidget: boolean = false;

  constructor(private translate: TranslateService, private modalService: FgbModalService, private router: Router) {}

  ngOnInit() {
    this.checkNewFanWidgetFlag();
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  /**
   * Check flag of
   * show new fan widget
   */
  checkNewFanWidgetFlag() {
    this.translate
      .stream('newfan.show.flag')
      .pipe(takeUntil(this._destroyed$))
      .subscribe((data: string) => {
        if (data === 'true') {
          this.showNewFanWidget = JSON.parse(data);
        }
      });
  }

  open(): void {
    if (window.innerWidth < 576) {
      this.modalService.openBottomMenu(HowItWorksModalComponent, {}, { startY: 60, draggable: false });
      return;
    }
    this.router.navigate(['/how-it-works'], { queryParams: { isHomePage: true } });
  }
}
